<ng-container *ngIf="!itinerarySettings || !itinerarySettings.entries">
    <h1 class="text-warning"> MISSING ITINERARY DATA! </h1>
    <h5 class="text-warning">add the 'itinerarySettings' parameter to &lt;app-itinerary-accordion&gt;!</h5>
</ng-container>

<ng-container *ngIf="itinerarySettings && itinerarySettings.entries">
    <accordion class="mb-5" [closeOthers]="shouldCloseOthers">
        <ng-container *ngFor="let entry of itinerarySettings.entries; let i = index">

            <accordion-group id="{{entry.contentId}}" class="card mb-3 px-0"
                             panelClass="itinClass"
                             [isOpen]="entry.contentId.substring(5) === isOpenOnPageEntry"
                             (isOpenChange)="toggleAccordion($event, entry)">
              <!-- Itinerary Card -->
              <button accordion-heading style="cursor: pointer;" class="btn btn-link btn-block d-flex justify-content-between align-middle card-btn py-0">
                <div class="container px-0">
                <div class="row">
                  <div class="col-10 text-truncate text-fg" [ngClass]="{'text-truncate': itinerarySettings.truncateHeader}">
                    <span>
                      <strong [ngClass]="isMobileSize() ? 'h6' : 'h5'">{{entry.title}}</strong>
                      <ng-container *ngIf="entry.start && entry.dest && !isMobileSize(); else mobileVers">
                        <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                        <div class="d-inline"><span>{{entry.start}}</span><app-fa-icon classes="mx-2" iconName="arrow-right"></app-fa-icon><span *ngIf="entry.mid">{{entry.mid}}</span><app-fa-icon *ngIf="entry.mid" classes="mx-2" iconName="arrow-right"></app-fa-icon><span>{{entry.dest}}</span></div>
                      </ng-container>
                      <ng-template #mobileVers>
                        <ng-container *ngIf="entry.mobileSubtitle">
                          <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                          <span class="text-fg-alt">{{entry.mobileSubtitle}}</span>
                        </ng-container>
                      </ng-template>
                    </span>
                  </div>
                  <div class="col-2 d-flex align-items-center">
                    <span class="card-btn-arrow ml-auto">
                      <app-fa-icon iconName="plus" color="link" *ngIf="!entry.isOpened" width="1" height="1" bottomMargin="-.2rem"></app-fa-icon>
                      <app-fa-icon iconName="minus" color="link" *ngIf="entry.isOpened" width="1" height="1" bottomMargin="-.2rem"></app-fa-icon>
                    </span>
                  </div>
                </div>
                </div>
              </button>

              <ng-container [ngTemplateOutlet]="getTemplateFromName(i+1)"></ng-container>
              <!-- End Itinerary Card -->
            </accordion-group>

        </ng-container>
    </accordion>
</ng-container>
